import React, { Component } from 'react'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import { ReactComponent as GenericError } from 'assets/images/generic-error.svg'

import { i18n } from 'localization'
import styles from './ErrorBoundary.module.sass'
import ClearSession from './ClearSession'

export default class ErrorBoundary extends Component {
	constructor() {
		super()
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(error) {
		if (error.message && error.message.indexOf(':') === 3) {
			const [status, message] = error.message.split(':')
			return {
				hasError: true,
				errorMessage: message,
				errorStatus: status,
			}
		}
		// Update state so the next render will show the fallback UI.
		return { hasError: true, errorMessage: error?.message }
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		// logErrorToMyService(error, errorInfo)
	}

	render() {
		if (this.state.hasError) {
			if (this.state.errorStatus === '401') {
				return <ClearSession />
			}
			if (this.props.render) {
				return this.props.render()
			}
			// You can render any custom fallback UI
			return (
				<Widget
					className={styles['root']}
					applyMaxWidth
					paddings={['normal', 'normal']}
				>
					<GenericError className={styles['graphics']} />
					<h1 className={styles['title']}>
						{this.state.errorMessage}
					</h1>
					<div>
						<p>
							<small>
								{i18n`An error occur. Please try again later.`}
							</small>
						</p>
						<p>
							<small>
								{i18n`If the problem persists, contact your system administration.`}
							</small>
						</p>
						<br />
						<ActionButton
							primary
							onClick={() => {
								window.location.reload()
							}}
						>
							Recarregar Página
						</ActionButton>
					</div>
				</Widget>
			)
		}

		return this.props.children
	}
}
